<template>
  <div
    id="div-loader"
    class="loader"
  >
    <img
      src="/images/ripple-loading-rebrand.gif"
      alt="loading"
    />

    <slot />
  </div>
</template>

<script setup>
defineOptions({
  name: 'AtomsLoadingAnimation'
})
</script>

<style scoped lang="scss" src="./index.scss"></style>
